<!-- 即时通讯 -->
<template>
  <ky-chat ref="kyChat" :login-params="loginParams" :createinfo.sync="createinfo"></ky-chat>
</template>

<script>
import {getUserInfoYT, createAskChatRoomParams} from '../../../packages/api/api.js'
import enc from '../../../packages/utils/enc.js'
export default {
  name: '',
  mixins: [],
  components: {},
  data () {
    return {
      loginParams: {},
      createinfo: {}
    }
  },
  watch: {},
  computed: {},
  async created () {
    /*  let info = {
      groupId: 'w0000001',
      roomName: '王患者的会诊',
      askId: 91,
      userIds: [
        {
          id: 'A001',
          userName: '李医生',
          dep: '呼吸科'
        },
        {
          id: 'A002',
          userName: '王患者',
          dep: '患者'
        }, {
          id: 'ad0b4b4e-df5b-4483-a6ee-6b1860616f06',
          userName: '管理员',
          dep: '综合科'
        }
      ]
    } */
    // let str = encodeURIComponent(enc.AESEncrypt(JSON.stringify(params), '4pQME1iaig+BZylP'))
    // console.log('str..........', str)
    // let str = 'W1YVbIM9yui7KVhMzjSRP3fdpVE8ieOzZDwwT2jxL6EuqpABFNL8MlxAT%2BsbD8Ft%2FRvwudPd4TWIYK%2BY2Z81PUzm3JxXzmMoHwAWTnXoiz8HHMU4r8chrA9jkqk0fbu812XdmqU9hRQNP7UcW9BPrw%3D%3D'
    // console.log('解码测试...', JSON.parse(enc.AESDecrypt(decodeURIComponent(str), '4pQME1iaig+BZylP')))
    // if (!window.httpConfig.login_type) { // 链接带id登录
    /* this.loginParams = {
        id: this.$route.query.id,
        pageType: this.$route.query.pageType,
        userName: this.$route.query.userName,
        dep: this.$route.query.dep
      } */
    let params = this.$route.query.params
    if (params) {
      this.loginParams = JSON.parse(enc.AESDecrypt(decodeURIComponent(params), '4pQME1iaig+BZylP'))
      if (window.httpConfig.otherSys === 'applet') {
        this.loginParams.pageType = '2'
      }
    }
    /*  this.loginParams = {
        dep: '呼吸科',
        id: 'A0001',
        pageType: '2',
        userName: '李医生',
        // userSex: 1, // 1：男 2：女
        userType: 1 // 0：患者 1：医生
      } */
    /* this.loginParams = {
        dep: '患者',
        id: '2ff06207998862cbkkd9590fkk695364664',
        pageType: '2',
        userName: '李梅',
        // userSex: 1, // 1：男 2：女
        userType: 0 // 0：患者 1：医生
      } */
    console.log('params参数', this.loginParams)
    if (this.$route.query.createinfo) {
      let str = this.$route.query.createinfo
      let info = JSON.parse(enc.AESDecrypt(decodeURIComponent(str), '4pQME1iaig+BZylP'))// 链接带创建房间参数
      console.log('createInfo', info)
      // console.log('createinfo', info)
      //   console.log('createinfo参数', info)
      /* let info = {
        askId: 77,
        groupId: 'akk9j987864425488k',
        isPay: 0,
        outTime: 30,
        questNum: 20,
        roomName: '李梅的咨询',
        roomType: '',
        userIds: [
          {
            dep: '呼吸科',
            id: 'A0001',
            img: 'https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83epwfBLkXfvprWoicMTRLo2U3ZibaX5hiaQ5cnGw0LCzAqic5dh6eBDdzLNzb4rqnpowCDJmEruvuVK3Kg/132',
            userName: '李医生'
          },
          {
            dep: '患者',
            id: '2ff06207998862cbkkd9590fkk695364664',
            userName: '李梅'
          }
        //   {
        //     dep: '患者',
        //     id: '2ff06207998862cbkkd9123fkk695364664',
        //     userName: '王梅'
        //   }
        ]
      } */
      /* let str2 = encodeURIComponent(enc.AESEncrypt(JSON.stringify(info), '4pQME1iaig+BZylP'))
      console.log('createinfo加密', str2) */
      this.createinfo = {
        type: 'createAuto',
        data: info
      }
    }
    // } else if (window.httpConfig.login_type === 'token') { // 链接带token登录
    let tokenStr = this.$route.query.token
    //   let tokenStr = 'ftfEmEfL3P/hmZDwFHeFzKWHT+C/VPO0AhxagxTzhJCXp0NaCiDXhcKoZDstpm1cqPtbOGWIpk9MNDgT0XGYVS9EThMJs35fefLureOEl1JsaQAX8YUvGX6VNNf23DN8kxtA89YDkIIBGs0xPRhBcrOyx61HR+B6pkC8aRKExLcVIqMGlO+lNwVR0VDlxXelup/gr/7HPPjxpsxLMYdibtGUk+RKi7vqSy1Lnse1cHK9GjsEeZHvccDL52UiqDIWYVnx4qmJ0ONbMSxQ9TaNNi0PmZcyn7eUyoT3junKHW/gLhoyVpT8lxoTSwDiu6hBr7j2pxiUsmBLoxN2rQiOzc2Oljaol+8eiEGh00PzBewF2GDGdspO73cPrDKRxz+jh1J0C+EVBb6xGimBUKbrP2Q2Mb2A6IOV2Ne0HUFBCR45K6ZtRWscB+tngNQ5Dlq44oCdrv4SrAEKFFWHtAA7vdodc70o3Y2eMPm3nf2L9aJiEaRbntnPtd7EkLCqlm6UZDYxvYDog5XY17QdQUEJHsuF3jVYXZtqcJ03V8TqhnVkNBSUiTPPaQqJOOdYsKjjDrKH8PvQrDrt6GeGowBr0Kgc+k0I9wcz+vhJ+/x1afggQtjrVKKo8MJ3I3vjvjk3r8cZol9608SQTO9L99+VE25xSbwLZfHix+SQnIXcYdir1v9xDUJEaHK0h28bK/ZHhEnYJntXF8tyoSKbSsvxjINBmT5sm9krxluOXS6VQQCTfbkJZR3GhZokKjbPv3kBQIQWKlQEYbFGm1ksStUtrnGz6g/1/ZHCWFORS+bJ2vukTncEja5heGPTDc9WXTFtlHXBfq/kSlhtIqbUSW3kND+u0pMX64aesWzV5Mc2x78QGPcq5wOMP0hRBEBTEwVEZDYxvYDog5XY17QdQUEJHu1JL29THeAUlZRXPSkFuL0k5Y8U6E11vqmJy1LITsu8Lo5HEv5vpO25HZqjqSfM2K2JWQ2Fo3NQ+Ti2WWJK8QONM7x/4z/OS2Q2JeOuP/IHxeJkGSKUq5Kuz31cynqefxL4xPB5ZtX5O9DVHBUfD/ePiprWs0d7yMH28ZvUdBIZ+dE0ELO7FFCAwGMBFOayaTldbV+LrmpxnKCYIXH7T8xnZ6Ecy38v+J7R+PBKjlluVrhzGca/RxLTdrRjEqGLePchobiT4YNKcAWFqJ81KGJXLQ7l8kxqa5jtOm+0NO7niX1lvT+mhmvuFLZGCGaB/ZYSHj4ZtzMO041nGwubKe8YZ4ko1vZuap//sKhM0HQ9NG1ly1MBuResUx4ulB4DcR8eJwx7FQtUu7/4N5KqHhv7+4XGyEGOfdjvgC3yp0AnnM+fdSXD/PhButtR3wnGF5qUE6svLhQGwzgUHXQGLsbq+4GYgGazi46lCY8MdbOo5mKlZpSxCrukSSzWO4uKnehZqQiAXvBHipprbeIFqPDICj51zPNUlDfPzB8FLPnagsKODHSUCo2qZDBWzjkIEqTw4forHBUKN1bEAX7UdRV7w4a5XuiwPM3Gi0o2C5z1FVJXyzPRJqFwP1REm1WUTDVX31H92YH37M4UqE5mmFDKLEx+vyU1W7JX2QntLnbtYP182rnZST5MlbN4dLD5MA=='
    if (tokenStr) {
      let token = JSON.parse(enc.AESDecrypt(decodeURIComponent(tokenStr), '4pQME1iaig+BZylP'))
      localStorage.setItem('YT_accessToken', token.accessToken)
      getUserInfoYT().then(async res => {
        if (res) {
          this.loginParams = {
            id: res.id,
            pageType: '1',
            userName: res.userName,
            dep: res.deptName
          }
        }
      })
    }

    if (this.$route.query.docId && this.$route.query.hosRegisterId) { // 兰天球登录，需要调和仁接口获得参数
      let params = {
        docCode: this.$route.query.docId,
        orderId: this.$route.query.hosRegisterId
      }
      await createAskChatRoomParams(params).then(data => {
        data = JSON.parse(data)
        if (data.code === 200) {
          this.loginParams = data.data.params
          this.loginParams.pageType = '2'
          this.createinfo = {
            type: 'createAuto', // 自动创建
            data: data.data.createinfo
          }
          console.log('this.loginParams', this.loginParams)
          console.log('this.createinfo', this.createinfo)
        }
      })
    }

    // }
  },
  mounted () {
    if (this.$route.query.sendMsg) { // 链接发送消息
      let sendMsg = this.$route.query.sendMsg
      sendMsg = JSON.parse(enc.AESDecrypt(decodeURIComponent(sendMsg), '4pQME1iaig+BZylP'))// 链接带创建房间参数
      this.$refs['kyChat'].sendMsg(sendMsg.type, sendMsg.data)
      /**
       * 评论消息 data格式
       * {
       *    comment:''//评论
       *    patientName:'',//患者姓名
       *    sex:'',//性别 //男/女/其他
       *    age:'',//年龄
       *    projectName:'',//项目名称
       * }
      */
    }
  },
  methods: {},
  beforeDestroy () {},
  destroyed () {},
  beforeUpdate () {},
  updated () {}
}
</script>
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// examples/views/chat/index.vue